import { ENQUEUE_NOTIFICATION, DEQUEUE_NOTIFICATION } from '../actions'

export default (prevState = [], { type, payload }) => {
  switch (type) {
    case ENQUEUE_NOTIFICATION:
      return prevState.concat(payload)
    case DEQUEUE_NOTIFICATION:
      return prevState.slice(1, prevState.length)
    default:
      return prevState
  }
}



// WEBPACK FOOTER //
// ./src/reducers/notificationQueue.js